import { DropZoneId } from '../models/drop-zone-id';

export function isValueZone(zone: DropZoneId): boolean {
    return ['lvalue', 'savalue', 'value', 'value1', 'value2'].includes(zone);
}
